var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChip({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 28,
    viewBox: "0 0 40 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.75 1H35C37.2091 1 39 2.79086 39 5V10.3889V17.6111V23C39 25.2091 37.2091 27 35 27H24.75H15.25H5C2.79086 27 1 25.2091 1 23V17.6111V10.3889V5C1 2.79086 2.79086 1 5 1H15.25H24.75Z",
    fill: "#F6C859"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.25 1H24.75M15.25 1H5C2.79086 1 1 2.79086 1 5V10.3889M15.25 1V5.69444M24.75 1H35C37.2091 1 39 2.79086 39 5V10.3889M24.75 1V5.69444H15.25M15.25 27H5C2.79086 27 1 25.2091 1 23V17.6111M15.25 27H24.75M15.25 27V22.3056M24.75 27H35C37.2091 27 39 25.2091 39 23V17.6111M24.75 27V22.3056M1 17.6111V10.3889M1 17.6111H15.25M39 17.6111V10.3889M39 17.6111H24.75M1 10.3889H15.25M39 10.3889H24.75V17.6111M15.25 10.3889V17.6111M15.25 10.3889V5.69444M15.25 17.6111V22.3056M24.75 17.6111V22.3056M15.25 22.3056H24.75",
    stroke: "#7D662D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChip);
export default __webpack_public_path__ + "static/media/chip.db6affce.svg";
export { ForwardRef as ReactComponent };